<template>
    <div
        class="modal fade"
        id="newEncounterModal"
        tabindex="-1"
        aria-labelledby="newEncounterModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content bg-dark text-light rounded-3 shadow-lg">
                <div class="modal-header">
                    <h5 class="modal-title" id="newEncounterModalLabel">
                        New Encounter
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>

                <div class="modal-body">
                    <div class="mb-3 input-group">
                        <span class="input-group-text">Encounter Name</span>
                        <input
                            type="text"
                            class="form-control"
                            id="encounter-name"
                            v-model="encounterName"
                            placeholder="Enter encounter name"
                        />
                    </div>
                </div>

                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="createEncounter"
                    >
                        Create
                    </button>

                    <!-- Hidden dismiss button we can "click" programmatically -->
                    <button
                        type="button"
                        ref="dismissBtn"
                        class="d-none"
                        data-bs-dismiss="modal"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useRosterStore } from "@/stores/index";
// IMPORTANT: remove any `import * as bootstrap from "bootstrap"` here.

export default {
    data() {
        return {
            encounterName: "",
            newEncounter: { name: "", monsters: [], doomclock: 0 },
        };
    },
    methods: {
        createEncounter() {
            this.newEncounter.name = this.encounterName;

            if (this.encounterName.trim() === "") {
                alert("Encounter name cannot be empty.");
                return;
            }

            const rosterStore = useRosterStore();
            if (
                rosterStore.encounters.some(
                    (e) => e.name === this.encounterName
                )
            ) {
                alert("An encounter with this name already exists.");
                return;
            }

            rosterStore.addEncounter(this.newEncounter);
            this.newEncounter = { name: "", monsters: [] };
            this.encounterName = "";

            // Close via Bootstrap's native dismiss mechanism (cleans up backdrop correctly)
            this.$refs.dismissBtn.click();
        },
    },
};
</script>

